// extracted by mini-css-extract-plugin
export default {"didYouMean":"__6f8nZF7AhSaa0JTTJd","label":"_0FJd5BFQZrXYLt8OW21D","suggestion":"ofhJYCF_yXSML0tlLx4o"};